<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">编号</span>
        <el-input v-model.trim="id" placeholder="请输入订单编号" style="width: 150px;"/>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">手机号</span>
	    <el-input v-model.trim="phone" placeholder="请输入手机号" style="width: 150px;"/>
	  </div>

     <div class="dlblock-mb20 mr10">
        <span class="pr5">商户编号</span>
        <el-input v-model.trim="merchantNumber" placeholder="请输入商户编号" style="width: 150px;"/>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">状态</span>
	    <el-select v-model="paymentStatus" class="w150" clearable>
	      <el-option v-for="(item, index) in statusList" :key="item.value" :label="item.key"
	                 :value="item.value"/>
	    </el-select>
	  </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="date"
	        style="width: 300px;"
	        type="daterange"
			format="yyyy-MM-dd HH:mm"
	        value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
	        range-separator="至"
	        start-placeholder="开始日期"
	        end-placeholder="结束日期"/>
	  </div>
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getSnhMerchantPageFn()">
          搜索
        </el-button>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <el-button type="primary" @click="getDwFlowDetailsExportFn()">
	      导出
	    </el-button>
	  </div>
	   
    </el-row>

	<br>
	
    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="id" label="编号"></el-table-column>
	  <el-table-column align="center" prop="merchantNumber" label="商户编号"></el-table-column>
	  <el-table-column align="center" prop="merchantName" label="商户名称"></el-table-column>
      <el-table-column align="center" prop="amount" label="金额"></el-table-column>
	  <el-table-column align="center" prop="paidin" label="实付金额"></el-table-column>
	  <el-table-column align="center" prop="fullReduction" label="优惠金额"></el-table-column>
	  <el-table-column align="center" prop="paymentStatusStr" label="订单状态"></el-table-column>
	  <el-table-column align="center" prop="thirdPartyUserId" label="第三方用户id"></el-table-column>
	  <el-table-column align="center" prop="phone" label="ABC手机号"></el-table-column>
	  <el-table-column align="center" prop="orderPaymentMethod" label="订单支付方式"></el-table-column>
	  <el-table-column align="center" prop="creationTime" label="创建时间"></el-table-column>
	 <!-- <el-table-column align="center"  prop="rspResults" label="下单响应状态"></el-table-column> -->
	 
      <el-table-column align="center" width="150" label="操作">
        <template slot-scope="{row}">
		  <a class="glob-a"  @click="editBtn(17, row)">更多</a>
		  <a class="glob-a"  @click="editBtn(52, row)">明细</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
	<!-- 更多 -->
	<el-dialog title="更多" :visible.sync="dialogMore.modal" width="400px">
	  
	   <!-- {{dialogMore.moreRow}} -->
	    
		 <!--   <a class="glob-a"  @click="editBtn(2, dialogMore.moreRow)">修改</a> -->
		          <a class="glob-a"  @click="editBtn(8, dialogMore.moreRow)">查看</a>  
			      <!-- <a class="glob-a"  @click="editBtn(18, dialogMore.moreRow)">同步old</a>
				  <a class="glob-a"  @click="editBtn(20, dialogMore.moreRow)">同步new</a> 
				  <a class="glob-a"  @click="editBtn(9, dialogMore.moreRow)">签约短信验证码重发</a> 
				  <a class="glob-a"  @click="editBtn(7, dialogMore.moreRow)">签约</a> 
				  <a class="glob-a"  @click="editBtn(6, dialogMore.moreRow)">状态变更</a> 
				  <a class="glob-a"  @click="editBtn(10, dialogMore.moreRow)">余额查询</a>
				  <a class="glob-a"  @click="editBtn(11, dialogMore.moreRow)">身份验证(非页面跳转)</a>
				  <a class="glob-a"  @click="editBtn(12, dialogMore.moreRow)">身份验证(页面跳转)</a>
				  <a class="glob-a"  @click="editBtn(13, dialogMore.moreRow)">授权支付签约(银行端)</a>
				  <a class="glob-a"  @click="editBtn(14, dialogMore.moreRow)">授权支付签约(商户端)—申请</a>
				  <a class="glob-a"  @click="editBtn(15, dialogMore.moreRow)">授权支付签约(商户端)—确认</a>
				  <a class="glob-a"  @click="editBtn(16, dialogMore.moreRow)">授权支付签约(商户端)—验证码重发</a>
				  <a class="glob-a"  @click="editBtn(19, dialogMore.moreRow)">掌银被扫支付请求</a>
				  <a class="glob-a"  @click="editBtn(21, dialogMore.moreRow)">授权支付签约/解约结果查询</a>
				  <a class="glob-a"  @click="editBtn(22, dialogMore.moreRow)">授权支付解约</a>
				  <a class="glob-a"  @click="editBtn(26, dialogMore.moreRow)">预授权确认/取消</a>
				  <a class="glob-a"  @click="editBtn(31, dialogMore.moreRow)">第三方POS对账单下载</a>
				  <a class="glob-a"  @click="editBtn(30, dialogMore.moreRow)">二级商户迁移</a>
				  <a class="glob-a"  @click="editBtn(32, dialogMore.moreRow)">查询POS（二级）商户T日清算金额</a> -->
				  
				  <a class="glob-a"  @click="editBtn(36, dialogMore.moreRow)">单笔退款</a>
				  <a class="glob-a"  @click="editBtn(37, dialogMore.moreRow)">单笔交易查询</a>
				  <a class="glob-a"  @click="editBtn(38, dialogMore.moreRow)">刷卡支付订单撤销请求</a> 
				<!--  <a class="glob-a"  @click="editBtn(47, dialogMore.moreRow)">担保确认查询请求</a> </br> -->
				  <a class="glob-a"  @click="editBtn(48, dialogMore.moreRow)">担保确认请求</a>
				  <a class="glob-a"  @click="editBtn(51, dialogMore.moreRow)">担保确认请求(垫资)</a>
				  
				  <a class="glob-a"  @click="editBtn(49, dialogMore.moreRow)">活动分析</a>
				<!--  <a class="glob-a"  @click="editBtn(50, dialogMore.moreRow)">微信支付宝刷卡支付订单撤销</a> -->
				  
				  
				  
				  <a class="glob-a"  @click="editBtn(5, dialogMore.moreRow)">删除</a>

	</el-dialog>
	
	<!-- 6.35	二级商户余额查询 查看 -->
	<el-dialog title="二级商户余额查询查看" :visible.sync="dialogMerchantBalance.modal" width="900px">
		<el-form label-width="160px">
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="商户编号：">
		        {{dialogMerchantBalance.data.merchant.merchantID}}
		      </el-form-item>
		    </el-col>
		    <el-col :span="12">
		      <el-form-item label="综合商户名称：" v-if="undefined != dialogMerchantBalance.data.trxResponse.merchantName" >
		        {{dialogMerchantBalance.data.trxResponse.merchantName}}
		      </el-form-item>
		    </el-col>
		  </el-row>
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="余额：">
		        {{dialogMerchantBalance.data.trxResponse.balance}}
		      </el-form-item>
		    </el-col>
			<el-col :span="12">
				<el-form-item label="二级商户号：">
				  {{dialogMerchantBalance.data.trxResponse.subMerId}}
				</el-form-item>
			</el-col>
		  </el-row>
		   <el-row>
			   <el-col :span="12">
			     <el-form-item label="出金号：">
			       {{dialogMerchantBalance.data.trxResponse.subMerchantAccNo}}
			     </el-form-item>
			   </el-col>
		   </el-row>
		</el-form> 
	</el-dialog>
	
	<!-- 6.35	单笔交易查询 查看 -->
	<el-dialog title="单笔交易查询" :visible.sync="dialogSingleTransactionQuery.modal" width="900px">
		<el-form label-width="160px" v-if="null!=dialogSingleTransactionQuery.data" >
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="支付类型：" >
		        {{dialogSingleTransactionQuery.data.payTypeID}} 
		      </el-form-item>
		    </el-col>
		    <el-col :span="12">
		      <el-form-item label="订单号：">
		        {{dialogSingleTransactionQuery.data.orderNo}}
		      </el-form-item>
		    </el-col>
		  </el-row>
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="订单日期：">
		        {{dialogSingleTransactionQuery.data.orderDate}}
		      </el-form-item>
		    </el-col>
			<el-col :span="12">
				<el-form-item label="订单时间：">
				  {{dialogSingleTransactionQuery.data.orderTime}}
				</el-form-item>
			</el-col>
		  </el-row>
		   <el-row>
			   <el-col :span="12">
			     <el-form-item label="订单金额：">
			       {{dialogSingleTransactionQuery.data.orderAmount}}
			     </el-form-item>
			   </el-col>
			   <el-col :span="12">
			     <el-form-item label="订单状态：">
			       {{dialogSingleTransactionQuery.data.statusStr}}
			     </el-form-item>
			   </el-col>
		   </el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="订单描述：">
					{{dialogSingleTransactionQuery.data.orderDesc}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="订单URL：">
					 {{dialogSingleTransactionQuery.data.orderURL}}
				</el-form-item>
			</el-col>
		</el-row>   
		<el-row>
			<el-col :span="12">
				<el-form-item label="支付渠道：">
					{{dialogSingleTransactionQuery.data.paymentLinkType}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="账号：">
					 {{dialogSingleTransactionQuery.data.acctNo}}
				</el-form-item>
			</el-col>
		</el-row>  
		<el-row>
			<el-col :span="12">
				<el-form-item label="商品类型：">
					{{dialogSingleTransactionQuery.data.commodityType}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="收货地址：">
					 {{dialogSingleTransactionQuery.data.receiverAddress}}
				</el-form-item>
			</el-col>
		</el-row>  
		<el-row>
			<el-col :span="12">
				<el-form-item label="IP：">
					{{dialogSingleTransactionQuery.data.buyIP}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="银行流水号：">
					 {{dialogSingleTransactionQuery.data.iRspRef}}
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="收款账户：">
					{{dialogSingleTransactionQuery.data.receiveAccount}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="收款户名：">
					 {{dialogSingleTransactionQuery.data.receiveAccName}}
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="附言：">
					{{dialogSingleTransactionQuery.data.merchantRemarks}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="用户ID：">
					 {{dialogSingleTransactionQuery.data.userID}}
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="三方商户订单号（微信、支付宝）：">
					{{dialogSingleTransactionQuery.data.thirdOrderNo}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="未知：">
					 {{dialogSingleTransactionQuery.data.thirdReOrderNo}}
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="农行支付会计日期，微信支付宝的客户支付时间：">
					{{dialogSingleTransactionQuery.data.szAccDate}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="未知：">
					 {{dialogSingleTransactionQuery.data.jRNNO}}
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="银行类别：">
					{{dialogSingleTransactionQuery.data.bankType}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="三方系统用户标示（微信、支付宝）：">
					 {{dialogSingleTransactionQuery.data.bUYER_USER_ID}}
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="未知：">
					{{dialogSingleTransactionQuery.data.wXRetNotifyZippedPayload}}
				</el-form-item>
			</el-col>
				<el-col :span="12">
					<el-form-item label="模板分账分账金额循环域：">
					 {{dialogSingleTransactionQuery.data.splitAccInfoItems}}
				</el-form-item>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<el-form-item label="订单详情循环域：">
					{{dialogSingleTransactionQuery.data.orderItems}}
				</el-form-item>
			</el-col>
		</el-row>
		</el-form> 
	</el-dialog>

    <!-- 6.45	二级商户信息查询 查看 -->
    <el-dialog title="查看" :visible.sync="auditShow.modal" width="900px">
      <el-form label-width="160px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="平台商户名称：" v-if=" undefined != auditShow.data.merchantName " >
              {{auditShow.data.merchantName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级商户编号：">
              {{auditShow.data.subMerId}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="二级商户名称：">
              {{auditShow.data.subMerName}}
            </el-form-item>
          </el-col>
		  <el-col :span="12">
		    <el-form-item label="排序方式：">
		      {{auditShow.data.subMerSort}}
		    </el-form-item>
		  </el-col>
        </el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="二级商户类型：">
		      {{auditShow.data.subMerchantType}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人证件类型：">
		      {{auditShow.data.CertificateType}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人证件编号：">
		      {{auditShow.data.certificateNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人名称：">
		      {{auditShow.data.contactName}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="银行预留手机号：">
		      {{auditShow.data.merMobileNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="状态：">
		      {{auditShow.data.status}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="二级商户状态说明：">
		      {{auditShow.data.statusMessage}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="企业证件类型：">
		      {{auditShow.data.companyCertType}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="企业证件号码：">
		      {{auditShow.data.companyCertNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="企业联系人名称：">
		      {{auditShow.data.companyName}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="通知地址：">
		      {{auditShow.data.notifyUrl}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="审核状态：">
		      {{auditShow.data.isPassed}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-table class="my-table" :data="auditShow.data.subAccountRecords" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
		  <el-table-column align="center" prop="accountType" label="账户类型"></el-table-column>
		  <el-table-column align="center" prop="accountName" label="账户名称"></el-table-column>
		  
		  <el-table-column align="center" prop="mobilePhone" label="二级商户手机号"></el-table-column>
		  <el-table-column align="center" prop="account" label="账户号"></el-table-column>
		  
		  <el-table-column align="center" prop="accountAbisNo" label="行内6网点号"></el-table-column>
		  <el-table-column align="center" prop="bankNo" label="账户开户行"></el-table-column>
		  
		  <el-table-column align="center" prop="accStatus" label="账户状态"></el-table-column>
		  <el-table-column align="center" prop="isABCAccount" label="是否是农行账号"></el-table-column>
		    
		</el-table>
		
		
      </el-form>
    </el-dialog>
	
	
	<!-- dw 扫码订单 明细 查看 -->
	<el-dialog title="扫码订单" :visible.sync="dwScancodeOrder.modal" width="900px">
	  <el-form label-width="160px">
	    <el-row>
	      <el-col :span="12">
	        <el-form-item label="编号：" v-if=" undefined != dwScancodeOrder.data.id " >
	          {{dwScancodeOrder.data.id}}
	        </el-form-item>
	      </el-col>
	      <el-col :span="12">
	        <el-form-item label="创建时间：">
	          {{dwScancodeOrder.data.creationTime}}
	        </el-form-item>
	      </el-col>
	    </el-row>
	   
	   <el-row>
	     <el-col :span="12">
	       <el-form-item label="订单编号：" v-if=" undefined != dwScancodeOrder.data.orderCode " >
	         {{dwScancodeOrder.data.orderCode}}
	       </el-form-item>
	     </el-col>
	     <el-col :span="12">
	       <el-form-item label="设备名称：">
	         {{dwScancodeOrder.data.deviceName}}
	       </el-form-item>
	     </el-col>
	   </el-row>
	   
	   <el-row>
	     <el-col :span="12">
	       <el-form-item label="商户名称：" v-if=" undefined != dwScancodeOrder.data.userName " >
	         {{dwScancodeOrder.data.userName}}
	       </el-form-item>
	     </el-col>
	     <el-col :span="12">
	       <el-form-item label="货道名称：">
	         {{dwScancodeOrder.data.devWayName}}
	       </el-form-item>
	     </el-col>
	   </el-row>
	   
	   <el-row>
	     <el-col :span="12">
	       <el-form-item label="产品名称：" v-if=" undefined != dwScancodeOrder.data.productName " >
	         {{dwScancodeOrder.data.productName}}
	       </el-form-item>
	     </el-col>
	     <el-col :span="12">
	       <el-form-item label="购买数量：">
	         {{dwScancodeOrder.data.productNum}}
	       </el-form-item>
	     </el-col>
	   </el-row>
	   
	   <el-row>
	     <el-col :span="12">
	       <el-form-item label="实收金额：" v-if=" undefined != dwScancodeOrder.data.sumMoney " >
	         {{dwScancodeOrder.data.sumMoney}}
	       </el-form-item>
	     </el-col>
	     <el-col :span="12">
	       <el-form-item label="订单状态：">
	         {{dwScancodeOrder.data.orderStatus}}
	       </el-form-item>
	     </el-col>
	   </el-row>
	   
	   <el-row>
	     <el-col :span="12">
	       <el-form-item label="付款方式：" v-if=" undefined != dwScancodeOrder.data.payType " >
	         {{dwScancodeOrder.data.payType}}
	       </el-form-item>
	     </el-col>
	   </el-row>
		
	  </el-form>
	</el-dialog>
	
	<!-- 6.53	二级商户签约短信验证码重发 -->
	<el-dialog title="商户签约短信验证码重发" :visible.sync="signUpSMS.modal" width="400px">
	  <el-form label-width="120px">
	  <el-form-item label="出金卡号：">
	    <el-input v-model.trim="signUpSMS.subMerchantAccNo" placeholder="请输入出金卡号"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="signUpSMS.modal = false">取 消</el-button>
	    <el-button type="primary" @click="signUpSMSBtn">确 定</el-button>
	  </div>
	</el-dialog>

  <!-- 新增编辑 -->
    <el-dialog :title="editData.add === 1 ? '新增商户' : '编辑商户'" :visible.sync="editData.modal" width="800px">
      <el-form label-width="220px">
        <el-form-item label="二级商户名称：">
          <el-input v-model.trim="editData.subMerName" placeholder="请输入二级商户名称"/>
        </el-form-item>
        <el-form-item label="二级商户类型：">
			<el-select v-model="editData.subMerType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in subMerTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
        </el-form-item>
  <!-- <el-form-item label="排序方式：">
		  <el-input v-model.trim="editData.subMerSort" placeholder="请输入排序方式"/>
		</el-form-item> -->
		<el-form-item label="法定代表人或负责人证件类型：">
			<el-select v-model="editData.certificateType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in certificateTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="法定代表人或负责人证件编号：">
		  <el-input v-model.trim="editData.certificateNo" placeholder="请输入法定代表人或负责人证件编号"/>
		</el-form-item>
		<el-form-item label="法定代表人或负责人名称：">
		  <el-input v-model.trim="editData.contactName" placeholder="请输入法定代表人或负责人名称"/>
		</el-form-item>
		<el-form-item label="企业名称：">
		  <el-input v-model.trim="editData.companyName" placeholder="企业商户必输"/>
		</el-form-item>
		<el-form-item label="企业证件类型：">
			<el-select v-model="editData.companyCertType" class="w150" placeholder="企业商户必选" clearable>
			  <el-option v-for="(item, index) in companyCertTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="企业证件编号：">
		  <el-input v-model.trim="editData.companyCertNo" placeholder="企业商户必输"/>
		</el-form-item>
		<el-form-item label="收款户名：">
		  <el-input v-model.trim="editData.accountName" placeholder="请输入收款户名"/>
		</el-form-item>
		<el-form-item label="收款账号：">
		  <el-input v-model.trim="editData.account" placeholder="请输入收款账号"/>
		</el-form-item>
		<el-form-item label="收款银行：">
		  <el-input v-model.trim="editData.bankName" placeholder="请输入收款银行"/>
		</el-form-item>
		<el-form-item label="银行预留手机号：">
		  <el-input v-model.trim="editData.mobilePhone" placeholder="请输入银行预留手机号"/>
		</el-form-item>
		<el-form-item label="地址：">
		  <el-input v-model.trim="editData.address" placeholder="非必须"/>
		</el-form-item>
		<el-form-item label="收款账户类型：">
			<el-select v-model="editData.accountType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in accountTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="商户负责人联系电话：">
		  <el-input v-model.trim="editData.merMobilePhone" placeholder="请输入商户负责人联系电话"/>
		</el-form-item>
		<el-form-item label="备注：">
		  <el-input v-model.trim="editData.remark" placeholder="非必须"/>
		</el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="editData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addBtn">确 定</el-button>
      </div>
    </el-dialog>
	
	<!-- 图片放大 -->
	<el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
	  <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	</el-dialog>
	
	<!-- 商户状态设置 -->
	<el-dialog title="商户状态设置" :visible.sync="statusData.modal" width="350px">
	  <el-form :model="statusData" >
	    <el-form-item label="商户状态：">
	    	<el-select v-model="statusData.updateFlag" class="w150" placeholder="选择" clearable>
	    	  <el-option v-for="(item, index) in merchantList" :key="index" :label="item.name" :value="item.value"/>
	    	</el-select>
	    </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="statusData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="statusSave">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 商户签约设置 -->
	<el-dialog title="商户签约设置" :visible.sync="signAcontractData.modal" width="320px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="短信验证码：">
	    <el-input v-model.trim="signAcontractData.verificationCode" placeholder="请输入短信验证码"/>
	  </el-form-item>
	  <el-form-item label="随机金额：">
	    <el-input v-model.trim="signAcontractData.randomAmount" placeholder="请输入随机金额"/>
	  </el-form-item>
	  <el-form-item label="出金卡号：">
	    <el-input v-model.trim="signAcontractData.account" placeholder="请输入出金卡号"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="signAcontractData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="signAcontract">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 14、交易明细查询 -->
	<el-dialog title="交易明细查询" :visible.sync="transactionDetailsData.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="transactionDetailsData.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="transactionDetailsData.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="transactionDetailsData.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="transactionDetailsData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="transactionDetails">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 6.11	交易对账单下载 -->
	<el-dialog title="交易对账单下载" :visible.sync="transactionAccountStatementDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="transactionAccountStatementDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="transactionAccountStatementDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="transactionAccountStatementDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="transactionAccountStatementDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="transactionAccountStatement">确 定</el-button>
	  </div>
	</el-dialog>

	<!-- 6.40	平台商户对账单下载 -->
	<el-dialog title="平台商户对账单下载" :visible.sync="platformMerchantStatementDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="platformMerchantStatementDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="platformMerchantStatementDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="platformMerchantStatementDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="platformMerchantStatementDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="platformMerchantStatement">确 定</el-button>
	  </div>
	</el-dialog>

	
	<!-- 新增编辑活动 -->
	  <el-dialog :title="activityViewData.add === 1 ? '新增活动' : '查看活动'" :visible.sync="activityViewData.modal" width="800px">
		<el-form label-width="220px">
	      <el-form-item label="名称：">
	        <el-input v-model.trim="activityViewData.activityName" placeholder="请输入活动名称"/>
	      </el-form-item>
	      <el-form-item label="类型：">
				<el-select v-model="activityViewData.type" class="w150" >
				  <el-option v-for=" item in subMerActivityTypeList " 
				  :key="item.value" :label="item.name" :value="item.value"/>
				</el-select>
	      </el-form-item>
	<!-- <el-form-item label="排序方式：">
			  <el-input v-model.trim="editData.subMerSort" placeholder="请输入排序方式"/>
			</el-form-item> -->
	<!-- <el-form-item label="法定代表人或负责人证件类型：">
				<el-select v-model="editData.certificateType" class="w150" placeholder="必选" clearable>
				  <el-option v-for="(item, index) in certificateTypeList" :key="index" :label="item.name" :value="item.value"/>
				</el-select>
			</el-form-item> -->
			<el-form-item label="活动总金额：">
			  <el-input v-model.trim="activityViewData.activityAmountLimit" placeholder="请输入活动总金额"/>
			</el-form-item>
			<el-form-item label="每日活动上线金额：">
			  <el-input v-model.trim="activityViewData.dailyActivityOnlineAmount" placeholder="请输入每日活动上线金额"/>
			</el-form-item>
			<el-form-item label="每日每人活动上线金额：">
			  <el-input v-model.trim="activityViewData.dailyOnlineAmountPerPerson" placeholder="请输入每日每人活动上线金额"/>
			</el-form-item>
			<el-form-item label="每人活动限制次数：">
			  <el-input v-model.trim="activityViewData.perPersonActivityLimitFrequency" placeholder="请输入每人活动限制次数"/>
			</el-form-item>
		<!--  <el-form-item label="企业证件类型：">
				<el-select v-model="editData.companyCertType" class="w150" placeholder="企业商户必选" clearable>
				  <el-option v-for="(item, index) in companyCertTypeList" :key="index" :label="item.name" :value="item.value"/>
				</el-select>
			</el-form-item> -->
			<el-form-item label="每人每日活动限制次数：">
			  <el-input v-model.trim="activityViewData.manDays" placeholder="请输入每人每日活动限制次数"/>
			</el-form-item>
			<el-form-item label="支付渠道：">
				<el-checkbox-group v-model="activityViewData.paymentChannelsArray"  >
				    <el-checkbox label="农行掌银" ></el-checkbox>
				    <el-checkbox label="微信"   ></el-checkbox>
				    <el-checkbox label="支付宝" ></el-checkbox>
				  </el-checkbox-group>
			</el-form-item>
			
			<el-form-item label="是否首次一元购买所有：" v-if="activityViewData.type == 3">
				  <el-radio-group v-model="activityViewData.firstDollar">
				      <el-radio :label="0">是</el-radio>
				      <el-radio :label="1">否</el-radio>
				  </el-radio-group>
			</el-form-item>
			
			<el-form-item label="是否当天一元购买所有：" v-if="activityViewData.type == 3">
				  <el-radio-group v-model="activityViewData.dayFirstDollar">
				      <el-radio :label="0">是</el-radio>
				      <el-radio :label="1">否</el-radio>
				  </el-radio-group>
			</el-form-item>
			
			
			<el-form-item label="是否当月一元购买所有：" v-if="activityViewData.type == 3">
				  <el-radio-group v-model="activityViewData.monthFirstDollar">
				      <el-radio :label="0">是</el-radio>
				      <el-radio :label="1">否</el-radio>
				  </el-radio-group>
			</el-form-item>
			
			<el-form-item label="是否活动时间内一元购买所有：" v-if="activityViewData.type == 3">
				  <el-radio-group v-model="activityViewData.duringActivityTimeFirstDollar">
				      <el-radio :label="0">是</el-radio>
				      <el-radio :label="1">否</el-radio>
				  </el-radio-group>
			</el-form-item>
			
			<el-form-item label="一元购买所有：" v-if="activityViewData.type == 3">
				 <el-input v-model.trim="activityViewData.oneYuan" placeholder="一元购买所有(默认一元,开启生效)"/>
			</el-form-item>
			
			<el-form-item label="使用条件：" v-if="activityViewData.type == 1">
			 满 <el-input v-model.trim="activityViewData.threshold" placeholder="请输入满减阀值" style="width: 40%;" /> 减
			  <el-input v-model.trim="activityViewData.preferentialSubsidy" placeholder="优惠补贴" style="width: 40%;" /> 
			</el-form-item>
			
			<el-form-item label="使用条件：" v-if="activityViewData.type == 2">
			 消费满 <el-input v-model.trim="activityViewData.threshold" placeholder="金额" style="width: 30%;" /> 随机立减
			  <el-input v-model.trim="activityViewData.preferentialSubsidy" placeholder="起" style="width: 20%;" /> 到
			  <el-input v-model.trim="activityViewData.preferentialSubsidyEnd" placeholder="止" style="width: 20%;" />
			</el-form-item>
			
			<el-form-item label="使用条件：" v-if="activityViewData.type == 3">
			 消费满 <el-input v-model.trim="activityViewData.threshold" placeholder="金额" style="width: 12%;" /> 第几次
			  <el-input v-model.trim="activityViewData.preferentialSubsidy" placeholder="起" style="width: 12%;" /> 到第几次打折
			  <el-input v-model.trim="activityViewData.preferentialSubsidyEnd" placeholder="止" style="width: 12%;" />折扣
			  <el-input v-model.trim="activityViewData.discount" placeholder="折扣" style="width: 12%;" />
			</el-form-item>
			
			<!-- type datetime -->
			<el-form-item label="活动时间：">
				<el-date-picker
				    v-model="activityViewData.activityTime"
				    style="width: 300px;"
					class="reset-clear"
				    type="daterange"  
					:clearable="false"
					unlink-panels
					start-placeholder="开始日期"
				    range-separator="至"
				    end-placeholder="结束日期"
					value-format="yyyy-MM-dd HH:mm:ss"
					:default-time="['00:00:00', '23:59:59']"
					/>
			</el-form-item>
		<!--	<el-form-item label="地址：">
			  <el-input v-model.trim="editData.address" placeholder="非必须"/>
			</el-form-item> -->
			<el-form-item label="状态：">
				<el-select v-model="activityViewData.state" class="w150" placeholder="必选" clearable>
				  <el-option v-for="(item, index) in accountActivityTypeList" :key="index" :label="item.name" :value="item.value"/>
				</el-select>
			</el-form-item>
			<el-form-item label="备注：">
			  <el-input type="textarea" v-model.trim="activityViewData.remarks" placeholder="非必须"/>
			</el-form-item>
	    </el-form>
	
	
	<br/>
	<el-form label-width="160px">
	  <el-row>
	    <el-col :span="12">
	      <el-form-item label="活动时间在不再范围内：">
	        {{activityViewData.activityTimeIsNoLongerInRange}}
	      </el-form-item>
	    </el-col>
	    <el-col :span="12">
	      <el-form-item label="活动开启状态：">
			 {{activityViewData.activityOpenState}}
	      </el-form-item>
	    </el-col>
	  </el-row>
	  <el-row>
	    <el-col :span="12">
	      <el-form-item label="是否一元购买所有：">
	        {{activityViewData.whetherToPurchaseAllForTheFirstTime}}
	      </el-form-item>
	    </el-col>
	    <el-col :span="12">
	      <el-form-item label="当前用户累计第多少笔：">
	        {{activityViewData.howManyTimesTheCurrentUserHasAccumulated}}
	      </el-form-item>
	    </el-col>
	  </el-row>
	</el-form> 
	
	 <div slot="footer">
	      <el-button @click="activityViewData.modal = false">取 消</el-button>
	    </div>
	  </el-dialog>
	  
	
  </div>
</template>

<script>
  import {
	//订单
	getSnhOrderPage,
	  
	//交易明细
	getSnhTransactionDetailsPage,
	//二级商户信息分页查看
    getSnhMerchantPage,
	//二级商户标记删除
	delSnhMerchantPage,
	//二级商户信息保存
	SecondaryMerchantsSynchronizeNew,
	//6.48	二级商户信息同步（新）
	secondaryMerchantInformationSynchronizationNew,
	//6.49	二级商户状态变更请求
	secondaryMerchantStatusChangeRequest,
	//6.5	二级商户签约确认
	signingConfirmationOfSecondaryMerchants,
	//6.45	二级商户信息查询
	secondaryMerchantInformationQuery,
	//6.35	二级商户余额查询
	secondaryMerchantBalanceQuery,
	//6.53	二级商户签约短信验证码重发
	sendMobileMessageForSubMerRequest,
	//6.26	身份验证（非页面跳转）
	authenticationNonPageJump,
	//6.24	身份验证（页面跳转）
	authenticationPageJump,
	//6、授权支付签约（银行端）
	authorizedPaymentSigningBankEnd,
	//6.16	授权支付签约（商户端）—申请
	authorizedPaymentSigningMerchantSideApplication,
	//6.17	授权支付签约（商户端）—确认
	authorizedPaymentSigningMerchantSideConfirmation,
	//6.18	授权支付签约（商户端）—验证码重发
	authorizedPaymentSigningMerchantSideVerificationCodeResend,
	//6.32	二级商户信息同步（不再支持）
	ydSnhRegSubMerchantInfoRequestOld,
	//6.44	掌银被扫支付请求
	ydSnhPalmBankIsSweptToPay,
	//6.20	授权支付签约/解约结果查询
	ydAuthorizedPaymentSigningCancelingResultQuery,
	//6.19	授权支付解约
	ydTerminationOfAuthorizedPayment,
	//6.11	对账单查询
	ydStatementQuery,
	//6.40	平台商户对账单下载
	ydPlatformMerchantStatementDownload,
	//6.27	预授权确认/取消
	ydPreAuthorizationConfirmationCancellation,
	//6.38	电子回单下载
	ydElectronicReceiptDownload,
	//6.40	鉴权交易结果查询（不再支持）
	ydAuthenticationQuery,
	//6.42	出金交易查询
	ydDepositTransactionInquiry,
	//6.46	二级商户迁移
	ydSecondaryBusinessMigration,
	//1、第三方POS对账单下载
	ydPOSThirdFileDownloadRequest,
	//2、查询POS（二级）商户T日清算金额
	ydQuerySubMerTdaySettleRequest,
	//3、第三方POS订单登记
	ydRegisterPOSOrderRequest,
	//4、第三方交易渠道订单确认
	ydThirdConfirmSendMQOrderRequest,
	//5、第三方交易渠道订单同步
	ydBatchRegisterRequest,
	//6.10	交易明细查询
	ydTransactionDetailEnquiry,
	//7.3	担保确认请求
	ydGuaranteeConfirmationRequest,
	//7.4	担保确认查询请求
	ydGuaranteeConfirmationInquiryRequest,
	//6.43	刷卡支付订单撤销请求
	getCreditCardPaymentOrderCancellationRequest,
	
	//6.6	单笔退款
	ydSingleRefund,
	//6.9	单笔交易查询
	ydSingleTransactionQuery,
	
	//活动查看
	ydGetActivityView,
	
	//扫码订单 明细
	getDwScancodeOrderTail
	
  } from '@/api'

    //导出文件专用
   import {getDwFlowDetailsExportUpcFn} from '@/api/indexUtil'
   
   import WordImg from '@/components/WordImg.vue'

  export default {
    name: 'WordList',
    components: {WordImg},
    data () {
      return {
		//二级商户编号
		subMerId:'',
		//二级商户名称
		subMerName:'',
        date: '',
        userName: '',
        tableData: [],
        tableLoading: false,
		//更多
		dialogMore:{
		modal:false,
		//更多选中操作列表中的一条
		moreRow:{}
		},
		//6.35	二级商户余额查询 查看
		dialogMerchantBalance:{
		  modal:false,
		  data:{
			  merchant:{merchantID:''},
			  trxResponse:{merchantName:''}
		  }
		},
		//6.45	二级商户信息查询
        auditShow: {
          modal: false,
          data: {
			  merchantName:'',
			  subAccountRecords:{}
		  }
        },
		//dw 扫码订单 明细
		dwScancodeOrder:{
			modal: false,
			data: {}
		},
		//6.53	二级商户签约短信验证码重发
		signUpSMS:{
			modal: false,
			data: {}
		},	
		//单笔交易查询
		dialogSingleTransactionQuery:{
			modal: false,
			data: {}
		},
		//二级商户类型
		subMerTypeList:[{name:"请选择",value:""},{name:"自然人",value:"1"},{name:"企业商户",value:"2"},{name:"个体工商户",value:"3"}],
		//法定代表人或负责人证件类型
		certificateTypeList:[{name:"请选择",value:""},{name:"身份证",value:"I"},{name:"护照",value:"P"},{name:"军官证",value:"G"},{name:"其它证件",value:"U"}],	
		//企业证件类型
		companyCertTypeList:[{name:"请选择",value:""},{name:"营业执照",value:"U"},{name:"组织机构代码证",value:"Y"},{name:"统一社会信用代码",value:"V"}],
		//收款账户类型
		accountTypeList:[{name:"请选择",value:""},{name:"借记卡",value:"401"},{name:"对公卡",value:"601"}],
		//商户状态
		merchantList:[{name:"请选择",value:""},{name:"开启",value:"6"},{name:"关闭",value:"5"},{name:"解约",value:"4"}],
		//单词新增和修改
        editData: {
          modal: false,
          userId: '',
          add: 1,
		  //二级商户名称
          subMerName: '',
		  //二级商户类型
		  subMerType:'',
		  //排序方式
		  subMerSort:'',
		  //法定代表人或负责人证件类型
		  certificateType:'',
		  //法定代表人或负责人证件编号
		  certificateNo:'',
		  //法定代表人或负责人名称
		  contactName:'',
		  //企业名称
		  companyName:'',
		  //企业证件类型
		  companyCertType:'',
		  //企业证件编号
		  companyCertNo:'',
		  //收款户名
		  accountName:'',
		  //收款账号
		  account:'',
		  //收款银行
		  bankName:'',
		  //银行预留手机号
		  mobilePhone:'',
		  //地址
		  address:'',
		  //收款账户类型
		  accountType:'',
		  //商户负责人联系电话
		  merMobilePhone:'',
		  //备注
		  remark:''
        },
		//活动
		activityViewData:{
		  modal: false,
		  //支付渠道
		  paymentChannels: [],
		  //支付渠道 数组
		  paymentChannelsArray:[],
		  //使用条件 满 多少 减 多少
		  threshold:'',
		  //优惠补贴
		  preferentialSubsidy:'',
		  //活动时间
		  activityTime:[],
		  
		  userId: '',
		  add: 1,
		  //二级商户名称
		  subMerName: '',
		  //类型
		  subMerType:'1',
		  //排序方式
		  subMerSort:'',
		  //法定代表人或负责人证件类型
		  certificateType:'',
		  //法定代表人或负责人证件编号
		  certificateNo:'',
		  //法定代表人或负责人名称
		  contactName:'',
		  //企业名称
		  companyName:'',
		  //企业证件类型
		  companyCertType:'',
		  //企业证件编号
		  companyCertNo:'',
		  //收款户名
		  accountName:'',
		  //收款账号
		  account:'',
		  //收款银行
		  bankName:'',
		  //银行预留手机号
		  mobilePhone:'',
		  //地址
		  address:'',
		  //收款账户类型
		  accountType:'',
		  //商户负责人联系电话
		  merMobilePhone:'',
		  //备注
		  remark:'',
		  //是否首次一元购买所有 0是 1否
		  firstDollar:'',
		  //折扣
		  discount:'',
		  //活动时间在不再范围内
		  activityTimeIsNoLongerInRange:'',
		  //活动开启状态
		  activityOpenState:'',
		  //是否一元购买所有
		  whetherToPurchaseAllForTheFirstTime:'',
		  //当前用户累计第多少笔
		  howManyTimesTheCurrentUserHasAccumulated:''
		  },
		  //活动类型
		  subMerActivityTypeList:[{name:"满减",value:"1"},{name:"随机立减",value:"2"},{name:"打折",value:"3"}],
		  //活动启用状态
		  accountActivityTypeList:[{name:"启用",value:"0"},{name:"关闭",value:"1"}],
		// 商户状态变更
		statusData: {
		  modal: false,
		  userId: '',
		  type: '',
		  typeName: '',
		  date: [],
		  content: ''
		},
		//商户签约设置
		signAcontractData:{
			modal: false,
			subMerId: '',
			verificationCode:'',
			randomAmount:'',
			account:''
		},
		//14 交易明细查询
		transactionDetailsData:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.11 交易对账单下载
		transactionAccountStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.40	平台商户对账单下载
		platformMerchantStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		imgTotal: 1,
		// 图片上传
		imgUploadData: {
		  modal: false,
		  urlList: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		//订单编号
		id:'',
		//商户编号
		merchantNumber:'',
		//手机号
		phone:'',
		
		//状态
		 statusList: [{key:"请选择",value:""},
		 {key:"未支付",value:"01"},
		 {key:"无回应",value:"02"},
		 {key:"微信和支付宝支付成功",value:"03"},
		 {key:"交易成功",value:"04"},
		 {key:"已退款",value:"05"},
		 {key:"授权确认成功",value:"07"},
		 {key:"授权已取消",value:"00"},
		 {key:"失败",value:"99"}
		 ],
		 //支付状态
		 paymentStatus:''
      }
    },
    created () {
      this.getSnhMerchantPageFn()
    },
    methods: {
		//6.48	二级商户信息同步（新）
		secondaryMerchantInformationSynchronizationNewFn () {
		  this.tableLoading = true
		  secondaryMerchantInformationSynchronizationNew({
			  id:this.editData.id
		  }).then(res => {
			  this.$message.success(res.data)
			  this.getSnhMerchantPageFn();
		  }).finally(() => {
		    this.tableLoading = false
		  })
		},
	  /**
	   * 查询流水
	   * */	
      getSnhMerchantPageFn(){
        this.tableLoading = true
        getSnhOrderPage({
          pageNum: this.pages.page,
          createTime: this.date && this.date.length ? this.date[0] : '',
          updateTime: this.date && this.date.length > 1 ? this.date[1] : '',
          id: this.id,
		  phone:this.phone,
          merchantNumber: this.merchantNumber,
		  paymentStatus:this.paymentStatus
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  //导出流水明细
	  getDwFlowDetailsExportFn(){
		  console.info("导出流水明细");
		  //导出excel
		    this.$confirm(`确认导出流水明细吗`, '提示', {
		  			    confirmButtonText: '确定',
		  			    cancelButtonText: '取消',
		  			    type: 'warning'
		  			  }).then(() => {
		  			     this.getDwFlowDetailsExportUpFn();
		  			});	
	  },
	  getDwFlowDetailsExportUpFn(){
	     this.tableLoading = true
	    getDwFlowDetailsExportUpcFn({
	      createTime: this.date && this.date.length ? this.date[0] : '',
	      updateTime: this.date && this.date.length > 1 ? this.date[1] : '',
	      id: this.id,
	      phone:this.phone,
	      merchantNumber: this.merchantNumber,
	      paymentStatus:this.paymentStatus
	    }).then(res => {
	        this.downloadFile(res)
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
	  // 文件下载导出
	    downloadFile(res) {
	    let url = window.URL.createObjectURL(new Blob([res.data]));
	    let link = document.createElement('a');
	    link.style.display = 'none';
	    link.href = url;
	    link.setAttribute('download', '交易流水明细.xls');
	    document.body.appendChild(link);
	    link.click()
	  },
	  //6.49	二级商户状态变更请求
	  statusSave(){
		 console.info("二级商户状态变更请求",this.statusData.subMerId);
		 this.tableLoading = true
		 secondaryMerchantStatusChangeRequest({subMerId:this.statusData.subMerId,
		 updateFlag:this.statusData.updateFlag}).then(res => {
		  this.$message.success(res.data)
		  //关闭弹窗
		  this.statusData = {modal: false}
		  this.tableLoading = false
		  this.getSnhMerchantPageFn()
		 }).finally(() => {
		   this.tableLoading = false
		 }) 
	  },
	  //6.35	二级商户余额查询
	  secondaryMerchantBalanceQueryFn(subMerId){
		 console.info("二级商户余额查询",subMerId);
		 this.tableLoading = true
		 secondaryMerchantBalanceQuery({subMerId:subMerId}).then(res => {
			 //弹出二级商户余额 显示dialog
			 //更多
			 this.dialogMerchantBalance = {
			 	  modal:true,
			 	  data:res.data	  
			 }
			 console.info("6.35	二级商户余额查询 ",this.dialogMerchantBalance);	 
		  this.$message.success(res.msg)
		  this.tableLoading = false
		 }).finally(() => {
		   this.tableLoading = false
		 })  
	  },
	  //商户签约
	  signAcontract(){
		  console.info("二级商户签约",this.signAcontractData.subMerId);
		  this.tableLoading = true
		  signingConfirmationOfSecondaryMerchants({
			  subMerchantNo:this.signAcontractData.subMerId,
		      verificationCode:this.signAcontractData.verificationCode,
			  randomAmount:this.signAcontractData.randomAmount,
			  account:this.signAcontractData.account,
		  }).then(res => {
			//签约
		   this.signAcontractData = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //6.10	交易明细查询
	  transactionDetails(){
		  this.tableLoading = true
		  ydTransactionDetailEnquiry({
					  //查询日期	必须设定，YYYY/MM/DD
		  			  settleDate:this.transactionDetailsData.settleDate,
					  //查询结束日期 必须设定，YYYY/MM/DD
					  settleDateEnd:this.transactionDetailsData.settleDateEnd,
					  //压缩标识	必须设定，1：压缩，0：不压缩
		  			  zip:this.transactionDetailsData.zip
		  }).then(res => {
		   this.transactionDetailsData = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //6.11 交易对账单下载
	  transactionAccountStatement(){
		  this.tableLoading = true
		  			ydStatementQuery({
		  				//查询日期	必须设定，YYYY/MM/DD
		  				settleDate:this.transactionAccountStatementDialog.settleDate,
		  				//查询结束日期 必须设定，YYYY/MM/DD
		  				settleDateEnd:this.transactionAccountStatementDialog.settleDateEnd,
		  				//压缩标识	必须设定，1：压缩，0：不压缩
		  				zip:this.transactionAccountStatementDialog.zip
		  			}).then(res => {
						this.transactionAccountStatementDialog = { modal: false }
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.40	平台商户对账单下载
	  platformMerchantStatement(){
		  //6.40	平台商户对账单下载
		  			this.tableLoading = true
		  			ydPlatformMerchantStatementDownload({
		  				//查询日期	必须设定，YYYY/MM/DD
		  				settleDate:this.platformMerchantStatementDialog.settleDate,
		  				//查询结束日期 必须设定，YYYY/MM/DD
		  				settleDateEnd:this.platformMerchantStatementDialog.settleDateEnd,
		  				//压缩标识	必须设定，1：压缩，0：不压缩
		  				zip:this.platformMerchantStatementDialog.zip
		  			}).then(res => {
						this.platformMerchantStatementDialog = { modal: false }
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.45	二级商户信息查询
	  secondaryMerchantInformationQueryFn(){
		  console.info("二级商户信息查询",this.auditShow.subMerId);
		  this.tableLoading = true
		  secondaryMerchantInformationQuery({
		  			  subMerId:this.auditShow.subMerId
		  }).then(res => {
		   this.auditShow.data = res.data;
		   if(res.data.accountRecords.length > 0){
		   this.auditShow.data.subAccountRecords = res.data.accountRecords[0]
		   }
		   //console.info(this.auditShow.data.subAccountRecords,"=======") //JSON.parse()
		   //this.$message.success(res)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //dw 扫码订单 明细
	  getDwScancodeOrderTailFn(idc){
	  		  console.info("dw 扫码订单 明细",idc);
	  		  this.tableLoading = true
	  		  getDwScancodeOrderTail({
	  		  			  id:idc
	  		  }).then(res => {
			   if(res.code == 200){  
					//this.tableLoading = false
					this.dwScancodeOrder = { modal:true, data:res.data }
			   }else{
				    this.$message.success(res.data)
			   }
	  		  }).finally(() => {
	  		    this.tableLoading = false
	  		  }) 
	  },
	  //二级商户标记删除
	  delSnhMerchantPageFn(id) {
		  console.info("二级商户标记删除",id);
	    this.tableLoading = true
	    delSnhMerchantPage({id:id}).then(res => {
	     this.$message.success(res.msg)
	     this.getSnhMerchantPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  editBtn(t,row) {
		  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除 6状态变更
		  if(t == 1){
			 this.editData = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			 }
		  }else if(t == 2){
			  console.info(row,"修改商户")
			  this.editData = {
			    modal: true,
			    id: row.id,
			    add: 2,
			    //二级商户名称
			    subMerName: row.subMerName,
			    //二级商户类型
			    subMerType:row.subMerType,
			    //排序方式
			    subMerSort:row.subMerSort,
			    //法定代表人或负责人证件类型
			    certificateType:row.certificateType,
			    //法定代表人或负责人证件编号
			    certificateNo:row.certificateNo,
			    //法定代表人或负责人名称
			    contactName:row.contactName,
			    //企业名称
			    companyName:row.companyName,
			    //企业证件类型
			    companyCertType:row.companyCertType,
			    //企业证件编号
			    companyCertNo:row.companyCertNo,
			    //收款户名
			    accountName:row.accountName,
			    //收款账号
			    account:row.account,
			    //收款银行
			    bankName:row.bankName,
			    //银行预留手机号
			    mobilePhone:row.mobilePhone,
			    //地址
			    address:row.address,
			    //收款账户类型
			    accountType:row.accountType,
			    //商户负责人联系电话
			    merMobilePhone:row.merMobilePhone,
			    //备注
			    remark:row.remark
			  }
		  }else if(t == 3) {
	      this.imgPreData = {
	        modal: true,
	        url: row.picture
	      }
	    }else if(t == 4) {
	      this.imgPreData = {
	        modal: true,
	        url: this.auditShow.data.picture
	      }
	    }else if(t == 5){
			this.$confirm(`确认要删除吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
				 let id =  row.id
			     this.delSnhMerchantPageFn(id);
			});
		}else if(t == 6){
			//商户状态变更
		this.statusData = {
		  modal: true,
		  subMerId: row.subMerId,
		  updateFlag: row.state,
		  date: [],
		  content: ''
		}
		}else if(t == 7){
			//签约
			this.signAcontractData = {
				modal: true,
				subMerId: row.subMerId,
				verificationCode:'',
				randomAmount:'',
				account:row.account
			}
		}else if(t == 8){
			//6.45	二级商户信息查询
			this.auditShow = {modal: true, subMerId: row.merchantNumber}
			this.secondaryMerchantInformationQueryFn()
		}else if(t == 9){
			//6.53	二级商户签约短信验证码重发
			this.signUpSMS = {
				modal: true,
				 subMerId: row.subMerId,
				 subMerchantAccNo:row.account
			}
		}else if(t == 10){
			//6.35	二级商户余额查询
			console.info("6.35	二级商户余额查询",row.merchantNumber)
			this.secondaryMerchantBalanceQueryFn(row.merchantNumber)
		}else if(t == 11){
			//6.26	身份验证（非页面跳转）
			console.info("6.26	身份验证（非页面跳转）");
			this.tableLoading = true
			authenticationNonPageJump({ 
				//客户类型
				customType:row.customType,
				//客户姓名
				clientName:row.accountName,
				//银行帐号
				accNo:row.account,
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType,
				//手机号
				mobileNo:row.merMobilePhone,
				//网银客户号
				customNo:'',
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 12){
			//6.24	身份验证（页面跳转）
			console.info("6.24	身份验证（页面跳转）");
			this.tableLoading = true
			authenticationPageJump({ 
				//客户类型
				customType:row.customType,
				//银行帐号
				bankCardNo:row.account,
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 13){
			//6、授权支付签约（银行端） 
			console.info("6、授权支付签约（银行端）");
			this.tableLoading = true
			authorizedPaymentSigningBankEnd({ 
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType,
				//交易渠道
				paymentLinkType:'1',
				//客户编号
				merCustomNo:row.subMerId,
				//卡类型
				cardType:'A',
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 14){
			//6.16	授权支付签约（商户端）—申请
			console.info("6.16	授权支付签约（商户端）—申请");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideApplication({ 
				//交易渠道
				paymentLinkType:'1',
				//客户编号
				merCustomNo:row.subMerId,
				//签约卡号
				cardNo:row.account,
				//卡类型
				cardType:'A',
				//手机号
				mobileNo:row.mobilePhone,
				//证件类型
				certificateType:row.certificateType,
				//证件号码
				certificateNo:row.certificateNo,
				//客户姓名
				accName:row.accountName
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 15){
			//6.17	授权支付签约（商户端）—确认
			console.info("6.17	授权支付签约（商户端）—确认");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideConfirmation({ 
				//交易编号	
				orderNo:'3GECEP01223743931840',
				//验证码	
				verifyCode:row.account
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 16){
			//6.18	授权支付签约（商户端）—验证码重发
			console.info("6.18	授权支付签约（商户端）—验证码重发");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideVerificationCodeResend({ 
				//交易编号	
				orderNo:'1',
				//签约卡号	
				cardNo:row.account
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 17 ){
			console.info("更多",row)
			//更多
			this.dialogMore = {
				  modal:true,
				  moreRow:row	  
			}
		}else if( t == 18 ){
			//同步old
			this.tableLoading = true
			ydSnhRegSubMerchantInfoRequestOld({ 
				//编号
				id: row.id
			}).then(res => {
			 this.$message.success(res.data)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 19 ){
			//6.44	掌银被扫支付请求
			this.tableLoading = true
			ydSnhPalmBankIsSweptToPay({ 
				//编号
				id: row.id,
				//二级商户编号
				subMerId:row.subMerId,
				//支付二维码信息
				payCode:6235613048944148431
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 20 ){
			//6.48	二级商户信息同步（新）
			this.editData.id = row.id
			this.secondaryMerchantInformationSynchronizationNewFn()
		}else if( t == 21 ){
			//6.20	授权支付签约/解约结果查询
			this.tableLoading = true
			ydAuthorizedPaymentSigningCancelingResultQuery({
				//签约编号
				orderNo:row.id
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 22 ){
			//6.19	授权支付解约
			this.tableLoading = true
			ydTerminationOfAuthorizedPayment({
				//交易编号
				orderNo:row.id,
				//签约编号
				agentSignNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 23 ){
			// 14、交易明细查询 弹出选择框
			this.transactionDetailsData = { modal: true }
		}else if( t == 24 ){
			//6.11	对账单查询
			this.transactionAccountStatementDialog = { modal: true }
		}else if( t == 25 ){
			//6.40	平台商户对账单下载
			this.platformMerchantStatementDialog = { modal: true }
		}else if( t == 26 ){
			//6.27	预授权确认/取消
			this.tableLoading = true
			ydPreAuthorizationConfirmationCancellation({
				//交易类型
				operateType:'',
				//交易日期
				orderDate:'',
				//交易时间
				orderTime:'',
				//交易编号
				orderNo:'',
				//原交易编号
				originalOrderNo:'',
				//币种
				currencyCode:'',
				//金额
				orderAmount:'',
				//手续费金额
				fee:'',
				//附言
				merchantRemarks:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 27 ){
			//6.38	电子回单下载
			this.tableLoading = true
			ydElectronicReceiptDownload({
				//二级商户编号
				subMerchantNo:'',
				//支付订单编号
				orderNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 28 ){
			//6.40	鉴权交易结果查询（不再支持）
			this.tableLoading = true
			ydAuthenticationQuery({
				//鉴权交易编号	必须设定
				transferNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 29 ){
			//6.42	出金交易查询
			this.tableLoading = true
			ydDepositTransactionInquiry({
				//外转（出金）交易编号	必须设定
				transferNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 30 ){
			//二级商户迁移
			this.tableLoading = true
			ydSecondaryBusinessMigration({
				//源平台商户号 必须设定
				fromMerchantNo:'',
				//待迁移二级商户编号   必须设定
				subMerchantNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 31 ){
			//第三方POS对账单下载
			this.tableLoading = true
			ydPOSThirdFileDownloadRequest({
				//二级商户号
				subMerchantID:'',
				//对账单下载日期
				fileDate:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 32){
			//查询POS（二级）商户T日清算金额 
			this.tableLoading = true
			ydQuerySubMerTdaySettleRequest({
				//二级商户号
				subMerchantNo:row.merchantNumber,
				//清算日期
				trxDate:'2021-05-12'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 33 ){
			//3、第三方POS订单登记
			this.tableLoading = true
			ydRegisterPOSOrderRequest({
				//二级商户号
				subMerchantNo:'',
				//订单号
				orderNo:'',
				//订单日期
				orderDate:'',
				//序列号
				sequenceNo:'',
				//订单金额
				amount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 34 ){
			//4、第三方交易渠道订单确认 
			this.tableLoading = true
			ydThirdConfirmSendMQOrderRequest({
				//订单号
				orderNo:'',
				//确认订单号
				newOrderNo:'',
				//确认金额
				orderAmount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 35 ){
			//5、第三方交易渠道订单同步
			this.tableLoading = true
			ydBatchRegisterRequest({
				//批次号
				batchNo:'',
				//批次日期
				batchDate:'',
				//批次日期
				batchTime:'',
				//本批次笔数
				batchCount:'',
				//本批次金额
				batchAmount:'',
				//交易总笔数
				totalCount:'',
				//交易总金额
				totalAmount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 36 ){
			//6.6	单笔退款
			this.tableLoading = true
			ydSingleRefund({
				//支付订单号		必须设定
				orderNo:row.id,
				//退款金额		必须设定
				trxAmount:row.paidin,
				//分账二级商户号
				splitMerchantID:row.merchantNumber,
				//平台商户担保支付退款资金来源
				//merRefundAccountFlag:'1'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 37 ){
			//6.9	单笔交易查询
			this.tableLoading = true
			ydSingleTransactionQuery({
				// 支付类型，ImmediatePay : 农行普通支付查询、
				//微信支付宝支付查询、农行普通退款查询、
				//微信支付宝退款查询上送，DividedPay : 分期支付查询上送
				payTypeID:'ImmediatePay',
				//交易编号		必须设定
				orderNo:row.id,
				//是否查询详细信息	必须设定, 0：状态查询； 1：详细查询
				queryDetail:'1'
			}).then(res => {
				if( res.code === 200 ){
				   this.$message.success(res.msg)
				   this.dialogSingleTransactionQuery = { modal:true ,data:res.data }
				}else{
				   this.$message.error(res.data)
				}
				//this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 38 ){
			//6.43	刷卡支付订单撤销请求
			this.tableLoading = true
			getCreditCardPaymentOrderCancellationRequest({
				//交易编号		必须设定
				orderNo:row.id,
				//商户模式	必须设定 1:大商户模式，0：非大商户模式
				modelFlag:'0',
				//支付渠道	必须设定 W:微信，Z：支付宝
				//merchantFlag:'Z',
				//订单支付方式
				orderPaymentMethod:row.orderPaymentMethod,
				//支付金额
				amount:row.amount
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if(t == 47 ){
			//7.4	担保确认查询请求
			this.tableLoading = true
			ydGuaranteeConfirmationInquiryRequest({
				//担保确认交易编号  未存储 存库
				orderNo:row.id,
				//二级商户号
				subMerchantNo:row.merchantNumber,
				//支付订单号
				orignalOrderNo:row.id
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 48 ){
			//7.3	担保确认请求
			this.tableLoading = true
			ydGuaranteeConfirmationRequest({
				//支付订单号
				orderNo:row.id,
				//订单金额
				orderAmount:row.paidin,
				//二级商户编号
				splitMerchantID:row.merchantNumber,
				//是否垫资 1:垫资； 0:非垫资
				advancedFund:'0'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 49 ){
			//活动分析
			this.tableLoading = true
			ydGetActivityView({
				//支付订单号
				orderNo:row.id,
				//二级商户编号
				splitMerchantID:row.merchantNumber,
				//活动编号
				activityNumber:row.activityNumber
			}).then(res => {
				if(res.code === 200 ){
					//活动
					this.activityViewData = {
									modal: true,
									//编号
									id: res.data.id,
									//活动名称
									activityName:res.data.activityName,
									//活动总金额
									activityAmountLimit:res.data.activityAmountLimit,
									//活动类型
									type:res.data.type,
									//每日活动上线金额
									dailyActivityOnlineAmount:res.data.dailyActivityOnlineAmount,
									//每日每人活动上线金额
									dailyOnlineAmountPerPerson:res.data.dailyOnlineAmountPerPerson,
									//每人活动限制次数
									perPersonActivityLimitFrequency:res.data.perPersonActivityLimitFrequency,
									//每人每日活动限制次数
									manDays:res.data.manDays,
									//支付渠道
									paymentChannels:res.data.paymentChannels,
									//支付渠道 数组
									paymentChannelsArray:res.data.paymentChannelsArray,
									//使用条件 满 多少 减 多少
									threshold:res.data.threshold,
									//优惠补贴
									preferentialSubsidy:res.data.preferentialSubsidy,
									//优惠补贴end
									preferentialSubsidyEnd:res.data.preferentialSubsidyEnd,
									//活动 开始时间 结束时间
									activityTime:[res.data.activityStartTime,res.data.activityEndTime],
									//状态
									state:res.data.state,
									//备注
									remarks:res.data.remarks,
									//是否首次一元购买所有 0是 1否
									firstDollar:res.data.firstDollar,
									//是否当天一元购买所有
									dayFirstDollar:res.data.dayFirstDollar,
									//是否当月一元购买所有
									monthFirstDollar:res.data.monthFirstDollar,
									//是否活动时间内一元购买所有
									duringActivityTimeFirstDollar:res.data.duringActivityTimeFirstDollar,
									//一元购买所有
									oneYuan:res.data.oneYuan,
									//折扣
									discount:res.data.discount,
									//活动时间在不再范围内
									activityTimeIsNoLongerInRange:res.data.activityTimeIsNoLongerInRange,
									//活动开启状态
									activityOpenState:res.data.activityOpenState,
									//是否一元购买所有
									whetherToPurchaseAllForTheFirstTime:res.data.whetherToPurchaseAllForTheFirstTime,
									//当前用户累计第多少笔
									howManyTimesTheCurrentUserHasAccumulated:res.data.howManyTimesTheCurrentUserHasAccumulated,
									//1新增 2编辑
									add: 2,
					}
				}else{
					this.$message.success(res.msg)	
				}
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 50 ){
			//待定
			this.$message.success("微信支付宝刷卡支付订单撤销")
		}else if( t == 51 ){
			//7.3	担保确认请求(垫资)
			this.tableLoading = true
			ydGuaranteeConfirmationRequest({
				//支付订单号
				orderNo:row.id,
				//订单金额
				orderAmount:row.paidin,
				//二级商户编号
				splitMerchantID:row.merchantNumber,
				//是否垫资 1:垫资； 0:非垫资
				advancedFund:'1'
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 52 ){
			//dw 扫码订单明细
			this.getDwScancodeOrderTailFn(row.id)
		}
	},
	//二级商户信息保存
	SecondaryMerchantsSynchronizeNewFn(){
	this.tableLoading = true
	SecondaryMerchantsSynchronizeNew({ 
		//编号
		id:this.editData.id,
		//二级商户编号
		subMerId:this.editData.subMerId,
		//二级商户名称
		subMerName: this.editData.subMerName,
		//二级商户类型
		subMerType:this.editData.subMerType,
		//排序方式
		subMerSort:this.editData.subMerSort,
		//状态 0:关闭 1:正常
		status:1,
		//法定代表人或负责人证件类型
		certificateType:this.editData.certificateType,
		//法定代表人或负责人证件编号
		certificateNo:this.editData.certificateNo,
		//法定代表人或负责人名称
		contactName:this.editData.contactName,
		//企业名称
		companyName:this.editData.companyName,
		//企业证件类型
		companyCertType:this.editData.companyCertType,
		//企业证件编号
		companyCertNo:this.editData.companyCertNo,
		//收款户名
		accountName:this.editData.accountName,
		//收款账号
		account:this.editData.account,
		//收款银行
		bankName:this.editData.bankName,
		//银行预留手机号
		mobilePhone:this.editData.mobilePhone,
		//地址
		address:this.editData.address,
		//收款账户类型
		accountType:this.editData.accountType,
		//商户负责人联系电话
		merMobilePhone:this.editData.merMobilePhone,
		//备注
		remark:this.editData.remark
	}).then(res => {
	 this.$message.success(res.msg)
	 this.tableLoading = false
	 this.editData.modal = false
	 //刷新
	 this.getSnhMerchantPageFn() 
	}).finally(() => {
	  this.tableLoading = false
	}) 
	},
	//6.53	二级商户签约短信验证码重发
	signUpSMSBtn(){
		console.info("二级商户签约短信验证码重发",this.signUpSMS.subMerId);
		this.tableLoading = true
		sendMobileMessageForSubMerRequest({
					  subMerId:this.signUpSMS.subMerId,
					  subMerchantAccNo:this.signUpSMS.subMerchantAccNo
		}).then(res => {
		 this.$message.success(res.msg)
		 this.tableLoading = false
		}).finally(() => {
		  this.tableLoading = false
		}) 
	},
	addBtn (t) {
	  if (this.editData.add == 1) {
		  //添加
		  this.SecondaryMerchantsSynchronizeNewFn()
	  } else {
		  //修改
		this.SecondaryMerchantsSynchronizeNewFn()
	  }
	},
	uploadSave() {
	  if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
	    addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
	      this.$message.success(res.data)
	      this.imgUploadData.modal = false
	      this.getImagePageFn()
	    })
	  }
	},
      pageChange (val) {
        this.pages.page = val
        this.getSnhMerchantPageFn()
      }
    }
  }
</script>

<style scoped>
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
